// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3omTt","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3xSPl"};